export const openAssignSubscription = payload => ({
  type: 'OPEN_ASSIGN_SUBSCRIPTION',
})

export const closeAssignSubscription = payload => ({
  type: 'CLOSE_ASSIGN_SUBSCRIPTION',
})
